import React, { Component } from 'react';
import PropTypes from 'prop-types';
import SelectItem from 'react-select-item';

import withFilters from '../../Filter/WithFilters';
import RangeFilterGenerator from '../../Filter/RangeFilterGenerator';
import SortSelector from '../../SortSelector/SortSelector';
import { ViewerPrimaryColorUserStyle } from '../../UserCustomization';

import './PropertyFilter.css';

/* eslint-disable max-len */
export class PropertyFilterComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      regions: [],
      counties: [],
      communities: [],
      previouslySelectedProjects: [],
      showSelectStateOrRegion: true,
    };
    this.handleAreaEventChange = this.handleAreaEventChange.bind(this);
  }

  componentWillMount() {
    this.setStateFromProps(this.props);
  }

  componentWillReceiveProps(nextProps) {
    const county = nextProps.filters.get('county') || null;
    const community = nextProps.filters.get('community') || null;
    this.setStateFromProps(nextProps);
    // preselect county if only 1 in org
    if (!county && this.state.counties.length === 1) {
      this.handleCountyEventChange([this.state.counties[0].id]);
    }
    // preselect community if only 1 in org
    if (!community && this.state.communities.length === 1) {
      this.handleCommunityEventChange([this.state.communities[0].id]);
    }
  }

  setStateFromProps(fromProps) {
    const {
      filters,
      filterValues,
      handleClear,
    } = fromProps;

    let stateFilter = filters.get('state');
    const regionFilter = filters.get('region');

    if (!stateFilter && (filterValues.states || []).length === 1) {
      stateFilter = filterValues.states;
      // preselect state if only 1 in org
      if (stateFilter.length === 1) {
        this.handleArrayEventChange(stateFilter, 'state');
      }
    }

    const previouslySelectedProjects = filters.get('projects') || ['10', '11'];

    let regions = (filterValues.regions || []);
    if (stateFilter) {
      const stateCounties = (filterValues.counties || []).filter(c => stateFilter.includes(c.state)).map(c => c.county_id);
      regions = regions.filter(r => {
        return r.counties && r.counties.some(c => stateCounties.indexOf(c.county_id) > -1);
      });
    }
    regions = regions.map(r => ({ id: r.metro_id, name: r.name, counties: r.counties }));

    if (regionFilter && !regionFilter.every(cf => regions.find(c => c.id === cf.id))) {
      handleClear('region');
    }

    const selectedRegions = regionFilter ? regionFilter.map(cf => regions.find(c => c.id === cf.id)) : null;
    const regionCounties = selectedRegions
      ? selectedRegions.reduce((map, r) => [...map, ...r.counties.map(c => c.county_id)], [])
      : null;


    const counties = (filterValues.counties || []).filter(c => {
      if (stateFilter && regionCounties) {
        return stateFilter.includes(c.state) && regionCounties.indexOf(c.county_id) > -1;
      } else if (regionCounties) {
        return regionCounties.indexOf(c.county_id) > -1;
      } else if (stateFilter) {
        return stateFilter.includes(c.state);
      }
      return false;
    })
    .map(c => ({ id: c.county_id, name: c.name }));

    const countyFilter = filters.get('county');
    if (countyFilter && !countyFilter.every(cf => counties.find(c => c.id === cf.id))) {
      handleClear('county');
    }

    const communities = (filterValues.communities || []).filter(c => {
      if (countyFilter) {
        return c.counties.some(county => countyFilter.find(cf => county.county_id === cf.id));
      } else if (stateFilter && regionCounties) {
        return stateFilter.includes(c.state) && c.counties.some(county => regionCounties.indexOf(county.county_id) > -1);
      } else if (regionCounties) {
        return c.counties.some(county => regionCounties.indexOf(county.county_id) > -1);
      } else if (stateFilter) {
        return stateFilter.includes(c.state);
      }
      return false;
    })
    .map(c => ({ id: c.community_id, name: c.name }));

    const communityFilter = filters.get('community');
    if (communityFilter && !communityFilter.every(cf => communities.find(c => c.id === cf.id))) {
      handleClear('community');
    }

    this.setState({
      regions,
      counties,
      communities,
      previouslySelectedProjects,
      showSelectStateOrRegion: !stateFilter && !regionFilter,
    });
  }

  handleAreaEventChange(event, stateArrayName) {
    const {
      handleEventChange,
      handleValueChange,
    } = this.props;

    if (event.target.value === 'reset') {
      handleEventChange(event);
    } else {
      const id = parseInt(event.target.value, 10);
      const area = this.state[stateArrayName].find(c => c.id === id);
      handleValueChange(event.target.name, { id, name: area.name });
    }
  }

  handleArrayEventChange(values, filter) {
    const {
      handleEventChange,
      handleValueChange,
    } = this.props;

    if (values.length === 0) {
      handleEventChange({ target: { name: filter, value: 'reset' } });
    } else {
      handleValueChange(filter, values);
    }
  }

  handleProjectsEventChange(values, filter) {
    const {
      handleEventChange,
      handleValueChange,
    } = this.props;
    let { previouslySelectedProjects } = this.state;

    if (values.length === 0) {
      handleEventChange({ target: { name: filter, value: 'reset' } });
      previouslySelectedProjects = [];
    } else {
      const vals = values.filter(v => v !== '10' && v !== '11' && v !== '0');
      if (vals.length) {
        if (previouslySelectedProjects.includes('11')) {
          previouslySelectedProjects = previouslySelectedProjects.filter(p => p !== '11');
          handleValueChange(filter, values.filter(v => v !== '11'));
        } else if (values.includes('11')) {
          previouslySelectedProjects.filter(p => p === '10' || p === '11' || p === '0');
          handleValueChange(filter, values.filter(v => v === '10' || v === '11' || v === '0'));
        } else {
          previouslySelectedProjects = values;
          handleValueChange(filter, values);
        }
      } else {
        previouslySelectedProjects = values;
        handleValueChange(filter, values);
      }
    }
    this.setState({
      ...this.state,
      previouslySelectedProjects,
    });
  }

  handleShowPropertiesEventChange(event, values) {
    if (event.target.checked) {
      values.push('10');
      this.handleArrayEventChange(values.filter(v => v !== '0'), 'projects');
    } else {
      values.push('0');
      this.handleArrayEventChange(values.filter(v => v !== '10'), 'projects');
    }
  }

  handleCommunityEventChange(values) {
    const filter = 'community';
    const {
      handleEventChange,
      handleValueChange,
    } = this.props;

    if (values.length === 0) {
      handleEventChange({ target: { name: filter, value: 'reset' } });
    } else {
      const objects = values.map(v => {
        const id = parseInt(v, 10);
        const area = this.state.communities.find(c => c.id === id);
        return { id, name: area.name };
      });
      handleValueChange(filter, objects);
    }
  }

  handleCountyEventChange(values) {
    const filter = 'county';
    const {
      handleEventChange,
      handleValueChange,
    } = this.props;
    if (values.length === 0) {
      handleEventChange({ target: { name: filter, value: 'reset' } });
    } else {
      const objects = values.map(v => {
        const id = parseInt(v, 10);
        const area = this.state.counties.find(c => c.id === id);
        return { id, name: area.name };
      });
      handleValueChange(filter, objects);
    }
  }

  handleRegionEventChange(values) {
    const filter = 'region';
    const {
      handleEventChange,
      handleValueChange,
    } = this.props;
    if (values.length === 0) {
      handleEventChange({ target: { name: filter, value: 'reset' } });
    } else {
      const objects = values.map(v => {
        const id = parseInt(v, 10);
        const area = this.state.regions.find(c => c.id === id);
        return { id, name: area.name };
      });
      handleValueChange(filter, objects);
    }
  }

  hasChildren = key => {
    return Boolean(this.state[key] && this.state[key].length);
  }

  render() {
    const {
      filters,
      filterValues,
      handleEventChange,
      handleValueChange,
      handleSubmit,
      properties,
      propertySort,
      isBuildings,
      isSites,
    } = this.props;

    const {
      regions,
      counties,
      communities,
      // showSelectStateOrRegion, // using hasChildren() instead
    } = this.state;

    const filteredLayers = (filterValues.layers || []).filter(layer => layer.limitToOutline);

    const projectsSelectLabel = 'Select Projects';
    const projects = (filterValues.projects || []).filter(v => v._id !== '10');

    if (!filters.get('projects')) {
      filters.set('projects', ['10', '11']);
    }

    let countiesSelectLabel = '';
    if (this.hasChildren('counties')) {
      countiesSelectLabel = 'All';
    } else if (!this.hasChildren('counties') && (!filters.get('state') && !filters.get('region'))) {
      countiesSelectLabel = 'Select a State or Region';
    } else {
      countiesSelectLabel = 'N/A';
    }

    let communitiesSelectLabel = '';
    if (this.hasChildren('communities')) {
      communitiesSelectLabel = 'All';
    } else if (!this.hasChildren('communities') && (!filters.get('state') && !filters.get('region'))) {
      communitiesSelectLabel = 'Select a State or Region';
    } else {
      communitiesSelectLabel = 'N/A';
    }

    return (
      <div className="properties-filters">
        <div className="toolbox-content filter-box">
          <form onSubmit={handleSubmit}>
            <div className="field__container">
              <div className="form-group field">
                <label htmlFor="search">Keyword Search</label>
                <input
                  className="form-control"
                  name="search"
                  onChange={e => handleEventChange(e)}
                  defaultValue={filters.get('search')}
                />
              </div>
              {isSites && (
                <div className="form-group field">
                  <label htmlFor="acres">Available Acres</label>
                  <RangeFilterGenerator
                    properties={properties}
                    filterValues={[filterValues.acres[0]]} // only set min value
                    filterable="acres"
                    selectedValue={filters.get('acres')}
                    handleChange={handleValueChange}
                    step={5}
                  />
                </div>
              )}
              {isBuildings && (
                <div className="form-group field">
                  <label htmlFor="sqft">Available Square Feet</label>
                  <RangeFilterGenerator
                    filterValues={[filterValues.sqft[0]]} // only set min value
                    properties={properties}
                    filterable="sqft"
                    selectedValue={filters.get('sqft')}
                    handleChange={handleValueChange}
                    step={1000}
                  />
                </div>
              )}
              {!!filteredLayers.length && (
                <div className="form-group field">
                  <label htmlFor="type">Spatial Search</label>
                  <SelectItem
                    label=" Select "
                    closeText="close"
                    onChange={values => this.handleArrayEventChange(values, 'shapefile')}
                    value={filters.get('shapefile')}
                    className="form-control shapefile"
                    multiple={false}
                  >
                    {
                      (filteredLayers).map(layer => {
                        return <option key={layer.id} value={layer}>{layer.title}</option>;
                      },
                    )}
                  </SelectItem>
                </div>
              )}
              {isBuildings && (
                <div className="form-group field">
                  <label htmlFor="type">Building Type</label>
                  <SelectItem
                    label=" All "
                    closeText="close"
                    onChange={values => this.handleArrayEventChange(values, 'buildingType')}
                    value={filters.get('buildingType') || []}
                    className="form-control"
                    multiple
                  >
                    {
                      (filterValues.buildingType || []).map(option => (
                        <option key={option} value={option}>{option}</option>
                      ),
                    )}
                  </SelectItem>
                </div>
              )}
              <div className="form-group field">
                <label htmlFor="specialtyFeatures">Specialty Features</label>
                <SelectItem
                  label=" All "
                  closeText="close"
                  onChange={values => this.handleArrayEventChange(values, 'specialtyFeatures')}
                  value={filters.get('specialtyFeatures') || []}
                  className="form-control"
                  multiple
                >
                  {
                    (filterValues.specialtyFeatures || []).map(option => (
                      <option key={option} value={option}>{option}</option>
                    ),
                  )}
                </SelectItem>
              </div>
              <div className="form-group field">
                <label htmlFor="railServed">Rail Served</label>
                <SelectItem
                  label=" All "
                  closeText="close"
                  onChange={values => this.handleArrayEventChange(values, 'railServed')}
                  value={filters.get('railServed') || []}
                  className="form-control"
                  multiple
                >
                  {
                    [
                      { name: 'Yes', value: 'Y' },
                      { name: 'No', value: 'N' },
                      { name: 'Unknown', value: 'U' },
                      { name: 'Possible', value: 'P' },
                    ].map(opt => (
                      <option key={opt.value} value={opt.value}>{opt.name}</option>
                    ),
                  )}
                </SelectItem>
              </div>
              <div className="form-group field">
                <label htmlFor="railAccessible">Rail Accessible</label>
                <SelectItem
                  label=" All "
                  closeText="close"
                  onChange={values => this.handleArrayEventChange(values, 'railAccessible')}
                  value={filters.get('railAccessible') || []}
                  className="form-control"
                  multiple
                >
                  {
                    [
                      { name: 'Yes', value: 'Y' },
                      { name: 'No', value: 'N' },
                      { name: 'Unknown', value: 'U' },
                    ].map(opt => (
                      <option key={opt.value} value={opt.value}>{opt.name}</option>
                    ),
                  )}
                </SelectItem>
              </div>
              {isBuildings && (
                <div className="form-group field">
                  <label htmlFor="multiTenant">Multi Tenant</label>
                  <SelectItem
                    label=" All "
                    closeText="close"
                    onChange={values => this.handleArrayEventChange(values, 'multiTenant')}
                    value={filters.get('multiTenant') || []}
                    className="form-control"
                    multiple
                  >
                    {
                      [
                        { name: 'Yes', value: 'Y' },
                        { name: 'No', value: 'N' },
                        { name: 'Unknown', value: 'U' },
                      ].map(opt => (
                        <option key={opt.value} value={opt.value}>{opt.name}</option>
                      ),
                    )}
                  </SelectItem>
                </div>
              )}
              <div className="form-group field">
                <label htmlFor="zoning">Zoning Descriptions</label>
                <SelectItem
                  label=" All "
                  closeText="close"
                  onChange={values => this.handleArrayEventChange(values, 'zoning')}
                  value={filters.get('zoning') || []}
                  className="form-control"
                  multiple
                >
                  {
                    (filterValues.zoning || []).map(option => (
                      <option key={option} value={option}>{option}</option>
                    ),
                  )}
                </SelectItem>
              </div>
              <div className="form-group field">
                <label htmlFor="saleLease">For Sale or Lease</label>
                <div className="switch-field switch-field-4">
                  <input
                    type="radio"
                    id="saleLeaseAll"
                    name="saleLease"
                    value="All"
                    checked={['Sale', 'Lease', 'Both'].indexOf(filters.get('saleLease')) === -1}
                    onChange={handleEventChange}
                  />
                  <ViewerPrimaryColorUserStyle domStyle={['Sale', 'Lease', 'Both'].indexOf(filters.get('saleLease')) === -1 && 'borderBottomColor'}>
                    <label htmlFor="saleLeaseAll">All</label>
                  </ViewerPrimaryColorUserStyle>
                  <input
                    type="radio"
                    id="saleLeaseSale"
                    name="saleLease"
                    value="Sale"
                    checked={filters.get('saleLease') === 'Sale'}
                    onChange={handleEventChange}
                  />
                  <ViewerPrimaryColorUserStyle domStyle={filters.get('saleLease') === 'Sale' && 'borderBottomColor'}>
                    <label htmlFor="saleLeaseSale">Sale</label>
                  </ViewerPrimaryColorUserStyle>
                  <input
                    type="radio"
                    id="saleLeaseLease"
                    name="saleLease"
                    value="Lease"
                    checked={filters.get('saleLease') === 'Lease'}
                    onChange={handleEventChange}
                  />
                  <ViewerPrimaryColorUserStyle domStyle={filters.get('saleLease') === 'Lease' && 'borderBottomColor'}>
                    <label htmlFor="saleLeaseLease">Lease</label>
                  </ViewerPrimaryColorUserStyle>
                  <input
                    type="radio"
                    id="saleLeaseBoth"
                    name="saleLease"
                    value="Both"
                    checked={filters.get('saleLease') === 'Both'}
                    onChange={handleEventChange}
                  />
                  <ViewerPrimaryColorUserStyle domStyle={filters.get('saleLease') === 'Both' && 'borderBottomColor'}>
                    <label htmlFor="saleLeaseBoth">Both</label>
                  </ViewerPrimaryColorUserStyle>
                </div>
              </div>
              {isSites && (
                <div className="form-group field">
                  <label htmlFor="siteCertified">Site Certified</label>
                  <div className="switch-field">
                    <input
                      type="radio"
                      id="siteCertifiedAny"
                      name="siteCertified"
                      value="All"
                      checked={filters.get('siteCertified') !== 'Y' && filters.get('siteCertified') !== 'N'}
                      onChange={handleEventChange}
                    />
                    <ViewerPrimaryColorUserStyle domStyle={(filters.get('siteCertified') !== 'Y' && filters.get('siteCertified') !== 'N') && 'borderBottomColor'}>
                      <label htmlFor="siteCertifiedAny">All</label>
                    </ViewerPrimaryColorUserStyle>
                    <input
                      type="radio"
                      id="siteCertifiedYes"
                      name="siteCertified"
                      value="Y"
                      checked={filters.get('siteCertified') === 'Y'}
                      onChange={handleEventChange}
                    />
                    <ViewerPrimaryColorUserStyle domStyle={filters.get('siteCertified') === 'Y' && 'borderBottomColor'}>
                      <label htmlFor="siteCertifiedYes">Yes</label>
                    </ViewerPrimaryColorUserStyle>
                    <input
                      type="radio"
                      id="siteCertifiedNo"
                      name="siteCertified"
                      value="N"
                      checked={filters.get('siteCertified') === 'N'}
                      onChange={handleEventChange}
                    />
                    <ViewerPrimaryColorUserStyle domStyle={filters.get('siteCertified') === 'N' && 'borderBottomColor'}>
                      <label htmlFor="siteCertifiedNo">No</label>
                    </ViewerPrimaryColorUserStyle>
                  </div>
                </div>
              )}
              <div className="form-group field">
                <label htmlFor="sqFtHigh">Sort List Results By</label>
                <SortSelector
                  selectedValue={filters.get('sort') || propertySort.join(':')}
                  handleChange={handleEventChange}
                >
                  {isBuildings && (<option value="sqft:high">SqFt High</option>)}
                  {isBuildings && (<option value="sqft:low">SqFt Low</option>)}
                  {isSites && (<option value="acres:high">Acres High</option>)}
                  {isSites && (<option value="acres:low">Acres Low</option>)}
                  <option value="name:low">Name A-Z</option>
                  <option value="name:high">Name Z-A</option>
                  <option value="nearestAirport:low">Closest Airport</option>
                  <option value="nearestInterstate:low">Closest Interstate</option>
                </SortSelector>
              </div>
              {isBuildings && filterValues.ceilingHeight &&
                <div className="form-group field">
                  <label htmlFor="ceilingHeight">Minimum Ceiling Peak</label>
                  <input
                    type="number"
                    className="form-control"
                    name="ceilingHeight"
                    onChange={e => handleEventChange(e)}
                    defaultValue={filters.get('ceilingHeight')}
                  />
                </div>
              }
              <div className="form-group field">
                <label htmlFor="state">State(s)</label>
                <SelectItem
                  label=" All "
                  closeText="close"
                  onChange={values => this.handleArrayEventChange(values, 'state')}
                  value={filters.get('state') || []}
                  className="form-control"
                  multiple
                >
                  {
                    (filterValues.states || []).map(opt => (
                      <option key={opt} value={opt}>{opt}</option>
                    ),
                  )}
                </SelectItem>
              </div>
              {/* <div className="form-group field"> */}
              <div className={`form-group field ${!this.hasChildren('regions') && 'readonly'}`}>
                <label htmlFor="region">Region</label>
                <SelectItem
                  // label="Select a Region"
                  label={this.hasChildren('regions') ? 'All' : 'N/A'}
                  closeText="close"
                  onChange={values => this.handleRegionEventChange(values)}
                  value={(filters.get('region') || []).map(r => r.id)}
                  className="form-control"
                  multiple
                >
                  {
                    (regions || []).map(opt => (
                      <option key={opt.id} value={opt.id}>{opt.name}</option>
                    ),
                  )}
                </SelectItem>
              </div>
              {/* <div className="form-group field"> */}
              <div className={`form-group field ${!this.hasChildren('counties') && 'readonly'}`}>
                <label htmlFor="county">County</label>
                <SelectItem
                  // label={showSelectStateOrRegion ? 'Select a State or Region' : ' All '}
                  label={countiesSelectLabel}
                  closeText="close"
                  onChange={values => this.handleCountyEventChange(values)}
                  value={(filters.get('county') || []).map(c => c.id)}
                  className="form-control"
                  multiple
                >
                  {
                    (counties || []).map(opt => (
                      <option key={opt.id} value={opt.id}>{opt.name}</option>
                    ),
                  )}
                </SelectItem>
              </div>
              {/* <div className="form-group field"> */}
              <div className={`form-group field ${!this.hasChildren('communities') && 'readonly'}`}>
                <label htmlFor="community">Community</label>
                <SelectItem
                  // label={showSelectStateOrRegion ? 'Select a State or Region' : ' All '}
                  label={communitiesSelectLabel}
                  closeText="close"
                  onChange={values => this.handleCommunityEventChange(values)}
                  value={(filters.get('community') || []).map(c => c.id)}
                  className="form-control community-select"
                  multiple
                >
                  {
                      (communities || []).map(option => (
                        <option key={option.id} value={option.id}>{option.name}</option>
                      ),
                    )}
                </SelectItem>
              </div>
              {isBuildings && filterValues.parkingSpaces &&
                <div className="form-group field">
                  <label htmlFor="parkingSpaces">Minimum Parking Spaces</label>
                  <input
                    type="number"
                    className="form-control"
                    name="parkingSpaces"
                    onChange={e => handleEventChange(e)}
                    defaultValue={filters.get('parkingSpaces')}
                  />
                </div>
              }
            </div>
            <div className="field__container">
              {projects.length > 0 && (
                <div className="form-group field">
                  <label htmlFor="project">Lasso Projects</label>
                  <SelectItem
                    // label={somethingelse}
                    label={projectsSelectLabel}
                    closeText="close"
                    onChange={values => this.handleProjectsEventChange(values, 'projects')}
                    value={filters.get('projects') || ['11']}
                    className="form-control"
                    multiple
                  >
                    {
                      (projects || []).map(opt => (
                        <option key={opt._id} value={opt._id}>{opt.name}</option>
                      ),
                    )}
                  </SelectItem>
                </div>)
              }
              {projects.length > 0 && (
                <div className="form-group field show-properties">
                  <label className="show-properties" htmlFor="showLOISProperties">Show LOIS Properties:</label>
                  <input
                    type="checkbox"
                    id="showLOISProperties"
                    name="showLOISProperties"
                    checked={(filters.get('projects') || ['10']).some(p => p === '10')}
                    onChange={e => this.handleShowPropertiesEventChange(e, (filters.get('projects') || []))}
                  />
                </div>
              )}
            </div>
            <div className="form-btn-wrapper">
              <ViewerPrimaryColorUserStyle domStyle="backgroundColor">
                <input type="submit" tabIndex="0" className="search__btn" value="Search" />
              </ViewerPrimaryColorUserStyle>
            </div>
          </form>
        </div>
      </div>
    );
  }
}

PropertyFilterComponent.propTypes = {
  properties: PropTypes.arrayOf(PropTypes.object),
  filterValues: PropTypes.object,
  propertySort: PropTypes.arrayOf(PropTypes.string),
  filters: PropTypes.object.isRequired,
  handleEventChange: PropTypes.func.isRequired,
  handleValueChange: PropTypes.func.isRequired,
  handleClear: PropTypes.func.isRequired, // eslint-disable-line react/no-unused-prop-types
  handleSubmit: PropTypes.func.isRequired,
  isBuildings: PropTypes.bool,
  isSites: PropTypes.bool,
};

PropertyFilterComponent.defaultProps = {
  filterValues: {},
};

export default withFilters(PropertyFilterComponent);



// WEBPACK FOOTER //
// ./src/components/Properties/PropertyFilter/PropertyFilter.js